import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const LeatherGuidePage = lazy(() => import('../pages/leather-guide/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LogoDownloadPage = lazy(() => import('../pages/logo-download/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/leather-guide",
    element: <LeatherGuidePage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/logo-download",
    element: <LogoDownloadPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
